export enum AccountTypeEnum {
  ROTH = 'roth',
  TRADITIONAL = 'traditional',
  BROKERAGE = 'brokerage',
  ROTH_INHERITED = 'roth-inherited',
  TRADITIONAL_INHERITED = 'traditional-inherited',
}
